import React, { useState, useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

interface StatItemProps {
  count: number;
  label: string;
}

const StatItem: React.FC<StatItemProps> = ({ count, label }) => {
  const [currentCount, setCurrentCount] = useState(0);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  
  const countingDone = useRef(false);
  
  useEffect(() => {
    if (inView && !countingDone.current) {
      countingDone.current = true;
      
      const duration = 2000; // 2 seconds
      const interval = 20; // Update every 20ms
      const increment = Math.ceil(count / (duration / interval));
      
      const timer = setInterval(() => {
        setCurrentCount(prevCount => {
          const newCount = prevCount + increment;
          if (newCount >= count) {
            clearInterval(timer);
            return count;
          }
          return newCount;
        });
      }, interval);
      
      return () => clearInterval(timer);
    }
  }, [inView, count]);

  return (
    <div ref={ref} className={`transition-opacity duration-700 ${inView ? 'opacity-100' : 'opacity-0'}`}>
      <div className="text-4xl font-bold mb-2">{currentCount}</div>
      <div className="text-base opacity-90">{label}</div>
    </div>
  );
};

const Stats: React.FC<{ language: string }> = ({ language }) => {
  return (
    <div className="py-20 px-4">
      <div className="max-w-6xl mx-auto bg-blue-500 text-white rounded-2xl py-12 px-8 my-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          <StatItem count={28} label={language === 'zh' ? '環球客戶' : 'Clients Worldwide'} />
          <StatItem count={30} label={language === 'zh' ? '完成專案' : 'Projects Completed'} />
          <StatItem count={16} label={language === 'zh' ? '工程人員' : 'Team Members'} />
          <StatItem count={96} label={language === 'zh' ? '滿意度' : 'Satisfaction Rate'} />
        </div>
      </div>
    </div>
  );
};

export default Stats;